import { render, staticRenderFns } from "./PaperPriceFormModal.vue?vue&type=template&id=515e808a&"
import script from "./PaperPriceFormModal.ts?vue&type=script&lang=js&"
export * from "./PaperPriceFormModal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports